const baseURL = 'https://democomida.solutiontechvp.com/';

export default baseURL;
